var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{staticClass:"footer-wrap"},[_c('a',{attrs:{"href":"https://www.linkedin.com/in/delarocha01/","target":"_blank"}},[_vm._v("Desarrollado por: Alberto de la Rocha")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }